// extracted by mini-css-extract-plugin
export default {"tooltip":"T0RZAh","tooltipArrow":"Yf6o7w","arrowWrapper":"aOnip6","tooltipContainer":"zxTdi2","tooltipTrigger":"BBAbHo"};